"use strict";
// tslint:disable
exports.__esModule = true;
exports.Boolean = {
    True: "https://schema.org/True",
    False: "https://schema.org/False"
};
exports.ActionStatusType = {
    /** An in-progress action (e.g, while watching the movie, or driving to a location). */
    ActiveActionStatus: "http://schema.org/ActiveActionStatus",
    /** An action that has already taken place. */
    CompletedActionStatus: "http://schema.org/CompletedActionStatus",
    /** An action that failed to complete. The action's error property and the HTTP return code contain more information about the failure. */
    FailedActionStatus: "http://schema.org/FailedActionStatus",
    /** A description of an action that is supported. */
    PotentialActionStatus: "http://schema.org/PotentialActionStatus"
};
/** @deprecated Use ActionStatusType as a variable instead. */
exports.ActionStatusTypeEnum = exports.ActionStatusType;
exports.Audience = {
    /** Researchers. */
    Researcher: "http://schema.org/Researcher"
};
/** @deprecated Use Audience as a variable instead. */
exports.AudienceEnum = exports.Audience;
exports.BoardingPolicyType = {
    /** The airline boards by groups based on check-in time, priority, etc. */
    GroupBoardingPolicy: "http://schema.org/GroupBoardingPolicy",
    /** The airline boards by zones of the plane. */
    ZoneBoardingPolicy: "http://schema.org/ZoneBoardingPolicy"
};
/** @deprecated Use BoardingPolicyType as a variable instead. */
exports.BoardingPolicyTypeEnum = exports.BoardingPolicyType;
exports.BookFormatType = {
    /** Book format: Audiobook. This is an enumerated value for use with the bookFormat property. There is also a type 'Audiobook' in the bib extension which includes Audiobook specific properties. */
    AudiobookFormat: "http://schema.org/AudiobookFormat",
    /** Book format: Ebook. */
    EBook: "http://schema.org/EBook",
    /** Book format: GraphicNovel. May represent a bound collection of ComicIssue instances. */
    GraphicNovel: "http://schema.org/GraphicNovel",
    /** Book format: Hardcover. */
    Hardcover: "http://schema.org/Hardcover",
    /** Book format: Paperback. */
    Paperback: "http://schema.org/Paperback"
};
/** @deprecated Use BookFormatType as a variable instead. */
exports.BookFormatTypeEnum = exports.BookFormatType;
exports.CarUsageType = {
    /** Indicates the usage of the vehicle for driving school. */
    DrivingSchoolVehicleUsage: "http://schema.org/DrivingSchoolVehicleUsage",
    /** Indicates the usage of the vehicle as a rental car. */
    RentalVehicleUsage: "http://schema.org/RentalVehicleUsage",
    /** Indicates the usage of the car as a taxi. */
    TaxiVehicleUsage: "http://schema.org/TaxiVehicleUsage"
};
/** @deprecated Use CarUsageType as a variable instead. */
exports.CarUsageTypeEnum = exports.CarUsageType;
exports.ContactPointOption = {
    /** Uses devices to support users with hearing impairments. */
    HearingImpairedSupported: "http://schema.org/HearingImpairedSupported",
    /** The associated telephone number is toll free. */
    TollFree: "http://schema.org/TollFree"
};
/** @deprecated Use ContactPointOption as a variable instead. */
exports.ContactPointOptionEnum = exports.ContactPointOption;
exports.DayOfWeek = {
    /** The day of the week between Thursday and Saturday. */
    Friday: "http://schema.org/Friday",
    /** The day of the week between Sunday and Tuesday. */
    Monday: "http://schema.org/Monday",
    /** This stands for any day that is a public holiday; it is a placeholder for all official public holidays in some particular location. While not technically a "day of the week", it can be used with {@link http://schema.org/OpeningHoursSpecification OpeningHoursSpecification}. In the context of an opening hours specification it can be used to indicate opening hours on public holidays, overriding general opening hours for the day of the week on which a public holiday occurs. */
    PublicHolidays: "http://schema.org/PublicHolidays",
    /** The day of the week between Friday and Sunday. */
    Saturday: "http://schema.org/Saturday",
    /** The day of the week between Saturday and Monday. */
    Sunday: "http://schema.org/Sunday",
    /** The day of the week between Wednesday and Friday. */
    Thursday: "http://schema.org/Thursday",
    /** The day of the week between Monday and Wednesday. */
    Tuesday: "http://schema.org/Tuesday",
    /** The day of the week between Tuesday and Thursday. */
    Wednesday: "http://schema.org/Wednesday"
};
/** @deprecated Use DayOfWeek as a variable instead. */
exports.DayOfWeekEnum = exports.DayOfWeek;
exports.DeliveryMethod = {
    /** A DeliveryMethod in which an item is collected on site, e.g. in a store or at a box office. */
    OnSitePickup: "http://schema.org/OnSitePickup"
};
/** @deprecated Use DeliveryMethod as a variable instead. */
exports.DeliveryMethodEnum = exports.DeliveryMethod;
exports.DigitalDocumentPermissionType = {
    /** Permission to add comments to the document. */
    CommentPermission: "http://schema.org/CommentPermission",
    /** Permission to read or view the document. */
    ReadPermission: "http://schema.org/ReadPermission",
    /** Permission to write or edit the document. */
    WritePermission: "http://schema.org/WritePermission"
};
/** @deprecated Use DigitalDocumentPermissionType as a variable instead. */
exports.DigitalDocumentPermissionTypeEnum = exports.DigitalDocumentPermissionType;
exports.DriveWheelConfigurationValue = {
    /** All-wheel Drive is a transmission layout where the engine drives all four wheels. */
    AllWheelDriveConfiguration: "http://schema.org/AllWheelDriveConfiguration",
    /** Four-wheel drive is a transmission layout where the engine primarily drives two wheels with a part-time four-wheel drive capability. */
    FourWheelDriveConfiguration: "http://schema.org/FourWheelDriveConfiguration",
    /** Front-wheel drive is a transmission layout where the engine drives the front wheels. */
    FrontWheelDriveConfiguration: "http://schema.org/FrontWheelDriveConfiguration",
    /** Real-wheel drive is a transmission layout where the engine drives the rear wheels. */
    RearWheelDriveConfiguration: "http://schema.org/RearWheelDriveConfiguration"
};
/** @deprecated Use DriveWheelConfigurationValue as a variable instead. */
exports.DriveWheelConfigurationValueEnum = exports.DriveWheelConfigurationValue;
exports.DrugCostCategory = {
    /** The drug's cost represents the maximum reimbursement paid by an insurer for the drug. */
    ReimbursementCap: "http://schema.org/ReimbursementCap",
    /** The drug's cost represents the retail cost of the drug. */
    Retail: "http://schema.org/Retail",
    /** The drug's cost represents the wholesale acquisition cost of the drug. */
    Wholesale: "http://schema.org/Wholesale"
};
/** @deprecated Use DrugCostCategory as a variable instead. */
exports.DrugCostCategoryEnum = exports.DrugCostCategory;
exports.DrugPregnancyCategory = {
    /** A designation by the US FDA signifying that adequate and well-controlled studies have failed to demonstrate a risk to the fetus in the first trimester of pregnancy (and there is no evidence of risk in later trimesters). */
    FDAcategoryA: "http://schema.org/FDAcategoryA",
    /** A designation by the US FDA signifying that animal reproduction studies have failed to demonstrate a risk to the fetus and there are no adequate and well-controlled studies in pregnant women. */
    FDAcategoryB: "http://schema.org/FDAcategoryB",
    /** A designation by the US FDA signifying that animal reproduction studies have shown an adverse effect on the fetus and there are no adequate and well-controlled studies in humans, but potential benefits may warrant use of the drug in pregnant women despite potential risks. */
    FDAcategoryC: "http://schema.org/FDAcategoryC",
    /** A designation by the US FDA signifying that there is positive evidence of human fetal risk based on adverse reaction data from investigational or marketing experience or studies in humans, but potential benefits may warrant use of the drug in pregnant women despite potential risks. */
    FDAcategoryD: "http://schema.org/FDAcategoryD",
    /** A designation by the US FDA signifying that studies in animals or humans have demonstrated fetal abnormalities and/or there is positive evidence of human fetal risk based on adverse reaction data from investigational or marketing experience, and the risks involved in use of the drug in pregnant women clearly outweigh potential benefits. */
    FDAcategoryX: "http://schema.org/FDAcategoryX",
    /** A designation that the drug in question has not been assigned a pregnancy category designation by the US FDA. */
    FDAnotEvaluated: "http://schema.org/FDAnotEvaluated"
};
/** @deprecated Use DrugPregnancyCategory as a variable instead. */
exports.DrugPregnancyCategoryEnum = exports.DrugPregnancyCategory;
exports.DrugPrescriptionStatus = {
    /** The character of a medical substance, typically a medicine, of being available over the counter or not. */
    OTC: "http://schema.org/OTC",
    /** Available by prescription only. */
    PrescriptionOnly: "http://schema.org/PrescriptionOnly"
};
/** @deprecated Use DrugPrescriptionStatus as a variable instead. */
exports.DrugPrescriptionStatusEnum = exports.DrugPrescriptionStatus;
exports.EventStatusType = {
    /** The event has been cancelled. If the event has multiple startDate values, all are assumed to be cancelled. Either startDate or previousStartDate may be used to specify the event's cancelled date(s). */
    EventCancelled: "http://schema.org/EventCancelled",
    /** The event has been postponed and no new date has been set. The event's previousStartDate should be set. */
    EventPostponed: "http://schema.org/EventPostponed",
    /** The event has been rescheduled. The event's previousStartDate should be set to the old date and the startDate should be set to the event's new date. (If the event has been rescheduled multiple times, the previousStartDate property may be repeated). */
    EventRescheduled: "http://schema.org/EventRescheduled",
    /** The event is taking place or has taken place on the startDate as scheduled. Use of this value is optional, as it is assumed by default. */
    EventScheduled: "http://schema.org/EventScheduled"
};
/** @deprecated Use EventStatusType as a variable instead. */
exports.EventStatusTypeEnum = exports.EventStatusType;
exports.GamePlayMode = {
    /** Play mode: CoOp. Co-operative games, where you play on the same team with friends. */
    CoOp: "http://schema.org/CoOp",
    /** Play mode: MultiPlayer. Requiring or allowing multiple human players to play simultaneously. */
    MultiPlayer: "http://schema.org/MultiPlayer",
    /** Play mode: SinglePlayer. Which is played by a lone player. */
    SinglePlayer: "http://schema.org/SinglePlayer"
};
/** @deprecated Use GamePlayMode as a variable instead. */
exports.GamePlayModeEnum = exports.GamePlayMode;
exports.GameServerStatus = {
    /** Game server status: OfflinePermanently. Server is offline and not available. */
    OfflinePermanently: "http://schema.org/OfflinePermanently",
    /** Game server status: OfflineTemporarily. Server is offline now but it can be online soon. */
    OfflineTemporarily: "http://schema.org/OfflineTemporarily",
    /** Game server status: Online. Server is available. */
    Online: "http://schema.org/Online",
    /** Game server status: OnlineFull. Server is online but unavailable. The maximum number of players has reached. */
    OnlineFull: "http://schema.org/OnlineFull"
};
/** @deprecated Use GameServerStatus as a variable instead. */
exports.GameServerStatusEnum = exports.GameServerStatus;
exports.GenderType = {
    /** The female gender. */
    Female: "http://schema.org/Female",
    /** The male gender. */
    Male: "http://schema.org/Male"
};
/** @deprecated Use GenderType as a variable instead. */
exports.GenderTypeEnum = exports.GenderType;
exports.HealthAspectEnumeration = {
    /** Content about the benefits and advantages of usage or utilization of topic. */
    BenefitsHealthAspect: "http://schema.org/BenefitsHealthAspect",
    /** Information about the causes and main actions that gave rise to the topic. */
    CausesHealthAspect: "http://schema.org/CausesHealthAspect",
    /** Content about contagion mechanisms and contagiousness information over the topic. */
    ContagiousnessHealthAspect: "http://schema.org/ContagiousnessHealthAspect",
    /** Information about how or where to find a topic. Also may contain location data that can be used for where to look for help if the topic is observed. */
    HowOrWhereHealthAspect: "http://schema.org/HowOrWhereHealthAspect",
    /** Information about coping or life related to the topic. */
    LivingWithHealthAspect: "http://schema.org/LivingWithHealthAspect",
    /** Related topics may be treated by a Topic. */
    MayTreatHealthAspect: "http://schema.org/MayTreatHealthAspect",
    /** Content about common misconceptions and myths that are related to a topic. */
    MisconceptionsHealthAspect: "http://schema.org/MisconceptionsHealthAspect",
    /** Overview of the content. Contains a summarized view of the topic with the most relevant information for an introduction. */
    OverviewHealthAspect: "http://schema.org/OverviewHealthAspect",
    /** Content about the real life experience of patients or people that have lived a similar experience about the topic. May be forums, topics, Q-and-A and related material. */
    PatientExperienceHealthAspect: "http://schema.org/PatientExperienceHealthAspect",
    /** Information about actions or measures that can be taken to avoid getting the topic or reaching a critical situation related to the topic. */
    PreventionHealthAspect: "http://schema.org/PreventionHealthAspect",
    /** Typical progression and happenings of life course of the topic. */
    PrognosisHealthAspect: "http://schema.org/PrognosisHealthAspect",
    /** Other prominent or relevant topics tied to the main topic. */
    RelatedTopicsHealthAspect: "http://schema.org/RelatedTopicsHealthAspect",
    /** Information about the risk factors and possible complications that may follow a topic. */
    RisksOrComplicationsHealthAspect: "http://schema.org/RisksOrComplicationsHealthAspect",
    /** Content about how to screen or further filter a topic. */
    ScreeningHealthAspect: "http://schema.org/ScreeningHealthAspect",
    /** Information about questions that may be asked, when to see a professional, measures before seeing a doctor or content about the first consultation. */
    SeeDoctorHealthAspect: "http://schema.org/SeeDoctorHealthAspect",
    /** Self care actions or measures that can be taken to sooth, health or avoid a topic. This may be carried at home and can be carried/managed by the person itself. */
    SelfCareHealthAspect: "http://schema.org/SelfCareHealthAspect",
    /** Side effects that can be observed from the usage of the topic. */
    SideEffectsHealthAspect: "http://schema.org/SideEffectsHealthAspect",
    /** Stages that can be observed from a topic. */
    StagesHealthAspect: "http://schema.org/StagesHealthAspect",
    /** Symptoms or related symptoms of a Topic. */
    SymptomsHealthAspect: "http://schema.org/SymptomsHealthAspect",
    /** Treatments or related therapies for a Topic. */
    TreatmentsHealthAspect: "http://schema.org/TreatmentsHealthAspect",
    /** Categorization and other types related to a topic. */
    TypesHealthAspect: "http://schema.org/TypesHealthAspect",
    /** Content about how, when, frequency and dosage of a topic. */
    UsageOrScheduleHealthAspect: "http://schema.org/UsageOrScheduleHealthAspect"
};
/** @deprecated Use HealthAspectEnumeration as a variable instead. */
exports.HealthAspectEnumerationEnum = exports.HealthAspectEnumeration;
exports.InfectiousAgentClass = {
    /** Pathogenic bacteria that cause bacterial infection. */
    Bacteria: "http://schema.org/Bacteria",
    /** Pathogenic fungus. */
    Fungus: "http://schema.org/Fungus",
    /** Multicellular parasite that causes an infection. */
    MulticellularParasite: "http://schema.org/MulticellularParasite",
    /** A prion is an infectious agent composed of protein in a misfolded form. */
    Prion: "http://schema.org/Prion",
    /** Single-celled organism that causes an infection. */
    Protozoa: "http://schema.org/Protozoa",
    /** Pathogenic virus that causes viral infection. */
    Virus: "http://schema.org/Virus"
};
/** @deprecated Use InfectiousAgentClass as a variable instead. */
exports.InfectiousAgentClassEnum = exports.InfectiousAgentClass;
exports.ItemAvailability = {
    /** Indicates that the item has been discontinued. */
    Discontinued: "http://schema.org/Discontinued",
    /** Indicates that the item is in stock. */
    InStock: "http://schema.org/InStock",
    /** Indicates that the item is available only at physical locations. */
    InStoreOnly: "http://schema.org/InStoreOnly",
    /** Indicates that the item has limited availability. */
    LimitedAvailability: "http://schema.org/LimitedAvailability",
    /** Indicates that the item is available only online. */
    OnlineOnly: "http://schema.org/OnlineOnly",
    /** Indicates that the item is out of stock. */
    OutOfStock: "http://schema.org/OutOfStock",
    /** Indicates that the item is available for pre-order, but will be delivered when generally available. */
    PreOrder: "http://schema.org/PreOrder",
    /** Indicates that the item is available for ordering and delivery before general availability. */
    PreSale: "http://schema.org/PreSale",
    /** Indicates that the item has sold out. */
    SoldOut: "http://schema.org/SoldOut"
};
/** @deprecated Use ItemAvailability as a variable instead. */
exports.ItemAvailabilityEnum = exports.ItemAvailability;
exports.ItemListOrderType = {
    /** An ItemList ordered with lower values listed first. */
    ItemListOrderAscending: "http://schema.org/ItemListOrderAscending",
    /** An ItemList ordered with higher values listed first. */
    ItemListOrderDescending: "http://schema.org/ItemListOrderDescending",
    /** An ItemList ordered with no explicit order. */
    ItemListUnordered: "http://schema.org/ItemListUnordered"
};
/** @deprecated Use ItemListOrderType as a variable instead. */
exports.ItemListOrderTypeEnum = exports.ItemListOrderType;
exports.LegalForceStatus = {
    /** Indicates that a legislation is in force. */
    InForce: "http://schema.org/InForce",
    /** Indicates that a legislation is currently not in force. */
    NotInForce: "http://schema.org/NotInForce",
    /** Indicates that parts of the legislation are in force, and parts are not. */
    PartiallyInForce: "http://schema.org/PartiallyInForce"
};
/** @deprecated Use LegalForceStatus as a variable instead. */
exports.LegalForceStatusEnum = exports.LegalForceStatus;
exports.LegalValueLevel = {
    /** Indicates that the publisher gives some special status to the publication of the document. ("The Queens Printer" version of a UK Act of Parliament, or the PDF version of a Directive published by the EU Office of Publications). Something "Authoritative" is considered to be also {@link http://schema.org/OfficialLegalValue OfficialLegalValue}". */
    AuthoritativeLegalValue: "http://schema.org/AuthoritativeLegalValue",
    /** Indicates a document for which the text is conclusively what the law says and is legally binding. (e.g. The digitally signed version of an Official Journal.)  Something "Definitive" is considered to be also {@link http://schema.org/AuthoritativeLegalValue AuthoritativeLegalValue}. */
    DefinitiveLegalValue: "http://schema.org/DefinitiveLegalValue",
    /** All the documents published by an official publisher should have at least the legal value level "OfficialLegalValue". This indicates that the document was published by an organisation with the public task of making it available (e.g. a consolidated version of a EU directive published by the EU Office of Publications). */
    OfficialLegalValue: "http://schema.org/OfficialLegalValue",
    /** Indicates that a document has no particular or special standing (e.g. a republication of a law by a private publisher). */
    UnofficialLegalValue: "http://schema.org/UnofficialLegalValue"
};
/** @deprecated Use LegalValueLevel as a variable instead. */
exports.LegalValueLevelEnum = exports.LegalValueLevel;
exports.MapCategoryType = {
    /** A parking map. */
    ParkingMap: "http://schema.org/ParkingMap",
    /** A seating map. */
    SeatingMap: "http://schema.org/SeatingMap",
    /** A transit map. */
    TransitMap: "http://schema.org/TransitMap",
    /** A venue map (e.g. for malls, auditoriums, museums, etc.). */
    VenueMap: "http://schema.org/VenueMap"
};
/** @deprecated Use MapCategoryType as a variable instead. */
exports.MapCategoryTypeEnum = exports.MapCategoryType;
exports.MedicalAudience = {
    /** Medical clinicians, including practicing physicians and other medical professionals involved in clinical practice. */
    Clinician: "http://schema.org/Clinician",
    /** Medical researchers. */
    MedicalResearcher: "http://schema.org/MedicalResearcher"
};
/** @deprecated Use MedicalAudience as a variable instead. */
exports.MedicalAudienceEnum = exports.MedicalAudience;
exports.MedicalDevicePurpose = {
    /** A medical device used for diagnostic purposes. */
    Diagnostic: "http://schema.org/Diagnostic",
    /** A medical device used for therapeutic purposes. */
    Therapeutic: "http://schema.org/Therapeutic"
};
/** @deprecated Use MedicalDevicePurpose as a variable instead. */
exports.MedicalDevicePurposeEnum = exports.MedicalDevicePurpose;
exports.MedicalEvidenceLevel = {
    /** Data derived from multiple randomized clinical trials or meta-analyses. */
    EvidenceLevelA: "http://schema.org/EvidenceLevelA",
    /** Data derived from a single randomized trial, or nonrandomized studies. */
    EvidenceLevelB: "http://schema.org/EvidenceLevelB",
    /** Only consensus opinion of experts, case studies, or standard-of-care. */
    EvidenceLevelC: "http://schema.org/EvidenceLevelC"
};
/** @deprecated Use MedicalEvidenceLevel as a variable instead. */
exports.MedicalEvidenceLevelEnum = exports.MedicalEvidenceLevel;
exports.MedicalImagingTechnique = {
    /** X-ray computed tomography imaging. */
    CT: "http://schema.org/CT",
    /** Magnetic resonance imaging. */
    MRI: "http://schema.org/MRI",
    /** Positron emission tomography imaging. */
    PET: "http://schema.org/PET",
    /** Radiography is an imaging technique that uses electromagnetic radiation other than visible light, especially X-rays, to view the internal structure of a non-uniformly composed and opaque object such as the human body. */
    Radiography: "http://schema.org/Radiography",
    /** Ultrasound imaging. */
    Ultrasound: "http://schema.org/Ultrasound",
    /** X-ray imaging. */
    XRay: "http://schema.org/XRay"
};
/** @deprecated Use MedicalImagingTechnique as a variable instead. */
exports.MedicalImagingTechniqueEnum = exports.MedicalImagingTechnique;
exports.MedicalObservationalStudyDesign = {
    /** A case series (also known as a clinical series) is a medical research study that tracks patients with a known exposure given similar treatment or examines their medical records for exposure and outcome. A case series can be retrospective or prospective and usually involves a smaller number of patients than the more powerful case-control studies or randomized controlled trials. Case series may be consecutive or non-consecutive, depending on whether all cases presenting to the reporting authors over a period of time were included, or only a selection. */
    CaseSeries: "http://schema.org/CaseSeries",
    /** Also known as a panel study. A cohort study is a form of longitudinal study used in medicine and social science. It is one type of study design and should be compared with a cross-sectional study.  A cohort is a group of people who share a common characteristic or experience within a defined period (e.g., are born, leave school, lose their job, are exposed to a drug or a vaccine, etc.). The comparison group may be the general population from which the cohort is drawn, or it may be another cohort of persons thought to have had little or no exposure to the substance under investigation, but otherwise similar. Alternatively, subgroups within the cohort may be compared with each other. */
    CohortStudy: "http://schema.org/CohortStudy",
    /** Studies carried out on pre-existing data (usually from 'snapshot' surveys), such as that collected by the Census Bureau. Sometimes called Prevalence Studies. */
    CrossSectional: "http://schema.org/CrossSectional",
    /** Unlike cross-sectional studies, longitudinal studies track the same people, and therefore the differences observed in those people are less likely to be the result of cultural differences across generations. Longitudinal studies are also used in medicine to uncover predictors of certain diseases. */
    Longitudinal: "http://schema.org/Longitudinal",
    /** An observational study design. */
    Observational: "http://schema.org/Observational",
    /** A registry-based study design. */
    Registry: "http://schema.org/Registry"
};
/** @deprecated Use MedicalObservationalStudyDesign as a variable instead. */
exports.MedicalObservationalStudyDesignEnum = exports.MedicalObservationalStudyDesign;
exports.MedicalProcedureType = {
    /** A type of medical procedure that involves noninvasive techniques. */
    NoninvasiveProcedure: "http://schema.org/NoninvasiveProcedure",
    /** A type of medical procedure that involves percutaneous techniques, where access to organs or tissue is achieved via needle-puncture of the skin. For example, catheter-based procedures like stent delivery. */
    PercutaneousProcedure: "http://schema.org/PercutaneousProcedure"
};
/** @deprecated Use MedicalProcedureType as a variable instead. */
exports.MedicalProcedureTypeEnum = exports.MedicalProcedureType;
exports.MedicalSpecialty = {
    /** A specific branch of medical science that pertains to study of anesthetics and their application. */
    Anesthesia: "http://schema.org/Anesthesia",
    /** A specific branch of medical science that pertains to diagnosis and treatment of disorders of heart and vasculature. */
    Cardiovascular: "http://schema.org/Cardiovascular",
    /** A field of public health focusing on improving health characteristics of a defined population in relation with their geographical or environment areas */
    CommunityHealth: "http://schema.org/CommunityHealth",
    /** A branch of medicine that is involved in the dental care. */
    Dentistry: "http://schema.org/Dentistry",
    /** Something relating to or practicing dermatology */
    Dermatologic: "http://schema.org/Dermatologic",
    /** A specific branch of medical science that pertains to diagnosis and treatment of disorders of skin. */
    Dermatology: "http://schema.org/Dermatology",
    /** Dietetic and nutrition as a medical speciality. */
    DietNutrition: "http://schema.org/DietNutrition",
    /** A specific branch of medical science that deals with the evaluation and initial treatment of medical conditions caused by trauma or sudden illness. */
    Emergency: "http://schema.org/Emergency",
    /** A specific branch of medical science that pertains to diagnosis and treatment of disorders of endocrine glands and their secretions. */
    Endocrine: "http://schema.org/Endocrine",
    /** A specific branch of medical science that pertains to diagnosis and treatment of disorders of digestive system. */
    Gastroenterologic: "http://schema.org/Gastroenterologic",
    /** A specific branch of medical science that pertains to hereditary transmission and the variation of inherited characteristics and disorders. */
    Genetic: "http://schema.org/Genetic",
    /** A specific branch of medical science that is concerned with the diagnosis and treatment of diseases, debilities and provision of care to the aged. */
    Geriatric: "http://schema.org/Geriatric",
    /** A specific branch of medical science that pertains to the health care of women, particularly in the diagnosis and treatment of disorders affecting the female reproductive system. */
    Gynecologic: "http://schema.org/Gynecologic",
    /** A specific branch of medical science that pertains to diagnosis and treatment of disorders of blood and blood producing organs. */
    Hematologic: "http://schema.org/Hematologic",
    /** Something in medical science that pertains to infectious diseases i.e caused by bacterial, viral, fungal or parasitic infections. */
    Infectious: "http://schema.org/Infectious",
    /** A medical science pertaining to chemical, hematological, immunologic, microscopic, or bacteriological diagnostic analyses or research */
    LaboratoryScience: "http://schema.org/LaboratoryScience",
    /** A nurse-like health profession that deals with pregnancy, childbirth, and the postpartum period (including care of the newborn), besides sexual and reproductive health of women throughout their lives. */
    Midwifery: "http://schema.org/Midwifery",
    /** A specific branch of medical science that pertains to diagnosis and treatment of disorders of muscles, ligaments and skeletal system. */
    Musculoskeletal: "http://schema.org/Musculoskeletal",
    /** A specific branch of medical science that studies the nerves and nervous system and its respective disease states. */
    Neurologic: "http://schema.org/Neurologic",
    /** A health profession of a person formally educated and trained in the care of the sick or infirm person. */
    Nursing: "http://schema.org/Nursing",
    /** A specific branch of medical science that specializes in the care of women during the prenatal and postnatal care and with the delivery of the child. */
    Obstetric: "http://schema.org/Obstetric",
    /** A specific branch of medical science that deals with benign and malignant tumors, including the study of their development, diagnosis, treatment and prevention. */
    Oncologic: "http://schema.org/Oncologic",
    /** The science or practice of testing visual acuity and prescribing corrective lenses. */
    Optometric: "http://schema.org/Optometric",
    /** A specific branch of medical science that is concerned with the ear, nose and throat and their respective disease states. */
    Otolaryngologic: "http://schema.org/Otolaryngologic",
    /** A specific branch of medical science that is concerned with the study of the cause, origin and nature of a disease state, including its consequences as a result of manifestation of the disease. In clinical care, the term is used to designate a branch of medicine using laboratory tests to diagnose and determine the prognostic significance of illness. */
    Pathology: "http://schema.org/Pathology",
    /** A specific branch of medical science that specializes in the care of infants, children and adolescents. */
    Pediatric: "http://schema.org/Pediatric",
    /** The practice or art and science of preparing and dispensing drugs and medicines. */
    PharmacySpecialty: "http://schema.org/PharmacySpecialty",
    /** The practice of treatment of disease, injury, or deformity by physical methods such as massage, heat treatment, and exercise rather than by drugs or surgery.. */
    Physiotherapy: "http://schema.org/Physiotherapy",
    /** A specific branch of medical science that pertains to therapeutic or cosmetic repair or re-formation of missing, injured or malformed tissues or body parts by manual and instrumental means. */
    PlasticSurgery: "http://schema.org/PlasticSurgery",
    /** Podiatry is the care of the human foot, especially the diagnosis and treatment of foot disorders. */
    Podiatric: "http://schema.org/Podiatric",
    /** The medical care by a physician, or other health-care professional, who is the patient's first contact with the health-care system and who may recommend a specialist if necessary. */
    PrimaryCare: "http://schema.org/PrimaryCare",
    /** A specific branch of medical science that is concerned with the study, treatment, and prevention of mental illness, using both medical and psychological therapies. */
    Psychiatric: "http://schema.org/Psychiatric",
    /** Branch of medicine that pertains to the health services to improve and protect community health, especially epidemiology, sanitation, immunization, and preventive medicine. */
    PublicHealth: "http://schema.org/PublicHealth",
    /** A specific branch of medical science that pertains to the study of the respiratory system and its respective disease states. */
    Pulmonary: "http://schema.org/Pulmonary",
    /** Radiography is an imaging technique that uses electromagnetic radiation other than visible light, especially X-rays, to view the internal structure of a non-uniformly composed and opaque object such as the human body. */
    Radiography: "http://schema.org/Radiography",
    /** A specific branch of medical science that pertains to the study of the kidneys and its respective disease states. */
    Renal: "http://schema.org/Renal",
    /** The therapy that is concerned with the maintenance or improvement of respiratory function (as in patients with pulmonary disease). */
    RespiratoryTherapy: "http://schema.org/RespiratoryTherapy",
    /** A specific branch of medical science that deals with the study and treatment of rheumatic, autoimmune or joint diseases. */
    Rheumatologic: "http://schema.org/Rheumatologic",
    /** The scientific study and treatment of defects, disorders, and malfunctions of speech and voice, as stuttering, lisping, or lalling, and of language disturbances, as aphasia or delayed language acquisition. */
    SpeechPathology: "http://schema.org/SpeechPathology",
    /** A specific branch of medical science that pertains to treating diseases, injuries and deformities by manual and instrumental means. */
    Surgical: "http://schema.org/Surgical",
    /** A specific branch of medical science that is concerned with poisons, their nature, effects and detection and involved in the treatment of poisoning. */
    Toxicologic: "http://schema.org/Toxicologic",
    /** A specific branch of medical science that is concerned with the diagnosis and treatment of diseases pertaining to the urinary tract and the urogenital system. */
    Urologic: "http://schema.org/Urologic"
};
/** @deprecated Use MedicalSpecialty as a variable instead. */
exports.MedicalSpecialtyEnum = exports.MedicalSpecialty;
exports.MedicalStudyStatus = {
    /** Active, but not recruiting new participants. */
    ActiveNotRecruiting: "http://schema.org/ActiveNotRecruiting",
    /** Completed. */
    Completed: "http://schema.org/Completed",
    /** Enrolling participants by invitation only. */
    EnrollingByInvitation: "http://schema.org/EnrollingByInvitation",
    /** Not yet recruiting. */
    NotYetRecruiting: "http://schema.org/NotYetRecruiting",
    /** Recruiting participants. */
    Recruiting: "http://schema.org/Recruiting",
    /** Results are available. */
    ResultsAvailable: "http://schema.org/ResultsAvailable",
    /** Results are not available. */
    ResultsNotAvailable: "http://schema.org/ResultsNotAvailable",
    /** Suspended. */
    Suspended: "http://schema.org/Suspended",
    /** Terminated. */
    Terminated: "http://schema.org/Terminated",
    /** Withdrawn. */
    Withdrawn: "http://schema.org/Withdrawn"
};
/** @deprecated Use MedicalStudyStatus as a variable instead. */
exports.MedicalStudyStatusEnum = exports.MedicalStudyStatus;
exports.MedicalTrialDesign = {
    /** A trial design in which neither the researcher nor the patient knows the details of the treatment the patient was randomly assigned to. */
    DoubleBlindedTrial: "http://schema.org/DoubleBlindedTrial",
    /** An international trial. */
    InternationalTrial: "http://schema.org/InternationalTrial",
    /** A trial that takes place at multiple centers. */
    MultiCenterTrial: "http://schema.org/MultiCenterTrial",
    /** A trial design in which the researcher knows the full details of the treatment, and so does the patient. */
    OpenTrial: "http://schema.org/OpenTrial",
    /** A placebo-controlled trial design. */
    PlaceboControlledTrial: "http://schema.org/PlaceboControlledTrial",
    /** A randomized trial design. */
    RandomizedTrial: "http://schema.org/RandomizedTrial",
    /** A trial design in which the researcher knows which treatment the patient was randomly assigned to but the patient does not. */
    SingleBlindedTrial: "http://schema.org/SingleBlindedTrial",
    /** A trial that takes place at a single center. */
    SingleCenterTrial: "http://schema.org/SingleCenterTrial",
    /** A trial design in which neither the researcher, the person administering the therapy nor the patient knows the details of the treatment the patient was randomly assigned to. */
    TripleBlindedTrial: "http://schema.org/TripleBlindedTrial"
};
/** @deprecated Use MedicalTrialDesign as a variable instead. */
exports.MedicalTrialDesignEnum = exports.MedicalTrialDesign;
exports.MedicineSystem = {
    /** A system of medicine that originated in India over thousands of years and that focuses on integrating and balancing the body, mind, and spirit. */
    Ayurvedic: "http://schema.org/Ayurvedic",
    /** A system of medicine focused on the relationship between the body's structure, mainly the spine, and its functioning. */
    Chiropractic: "http://schema.org/Chiropractic",
    /** A system of medicine based on the principle that a disease can be cured by a substance that produces similar symptoms in healthy people. */
    Homeopathic: "http://schema.org/Homeopathic",
    /** A system of medicine focused on promoting the body's innate ability to heal itself. */
    Osteopathic: "http://schema.org/Osteopathic",
    /** A system of medicine based on common theoretical concepts that originated in China and evolved over thousands of years, that uses herbs, acupuncture, exercise, massage, dietary therapy, and other methods to treat a wide range of conditions. */
    TraditionalChinese: "http://schema.org/TraditionalChinese",
    /** The conventional Western system of medicine, that aims to apply the best available evidence gained from the scientific method to clinical decision making. Also known as conventional or Western medicine. */
    WesternConventional: "http://schema.org/WesternConventional"
};
/** @deprecated Use MedicineSystem as a variable instead. */
exports.MedicineSystemEnum = exports.MedicineSystem;
exports.MusicAlbumProductionType = {
    /** CompilationAlbum. */
    CompilationAlbum: "http://schema.org/CompilationAlbum",
    /** DemoAlbum. */
    DemoAlbum: "http://schema.org/DemoAlbum",
    /** DJMixAlbum. */
    DJMixAlbum: "http://schema.org/DJMixAlbum",
    /** LiveAlbum. */
    LiveAlbum: "http://schema.org/LiveAlbum",
    /** MixtapeAlbum. */
    MixtapeAlbum: "http://schema.org/MixtapeAlbum",
    /** RemixAlbum. */
    RemixAlbum: "http://schema.org/RemixAlbum",
    /** SoundtrackAlbum. */
    SoundtrackAlbum: "http://schema.org/SoundtrackAlbum",
    /** SpokenWordAlbum. */
    SpokenWordAlbum: "http://schema.org/SpokenWordAlbum",
    /** StudioAlbum. */
    StudioAlbum: "http://schema.org/StudioAlbum"
};
/** @deprecated Use MusicAlbumProductionType as a variable instead. */
exports.MusicAlbumProductionTypeEnum = exports.MusicAlbumProductionType;
exports.MusicAlbumReleaseType = {
    /** AlbumRelease. */
    AlbumRelease: "http://schema.org/AlbumRelease",
    /** BroadcastRelease. */
    BroadcastRelease: "http://schema.org/BroadcastRelease",
    /** EPRelease. */
    EPRelease: "http://schema.org/EPRelease",
    /** SingleRelease. */
    SingleRelease: "http://schema.org/SingleRelease"
};
/** @deprecated Use MusicAlbumReleaseType as a variable instead. */
exports.MusicAlbumReleaseTypeEnum = exports.MusicAlbumReleaseType;
exports.MusicReleaseFormatType = {
    /** CassetteFormat. */
    CassetteFormat: "http://schema.org/CassetteFormat",
    /** CDFormat. */
    CDFormat: "http://schema.org/CDFormat",
    /** DigitalAudioTapeFormat. */
    DigitalAudioTapeFormat: "http://schema.org/DigitalAudioTapeFormat",
    /** DigitalFormat. */
    DigitalFormat: "http://schema.org/DigitalFormat",
    /** DVDFormat. */
    DVDFormat: "http://schema.org/DVDFormat",
    /** LaserDiscFormat. */
    LaserDiscFormat: "http://schema.org/LaserDiscFormat",
    /** VinylFormat. */
    VinylFormat: "http://schema.org/VinylFormat"
};
/** @deprecated Use MusicReleaseFormatType as a variable instead. */
exports.MusicReleaseFormatTypeEnum = exports.MusicReleaseFormatType;
exports.OfferItemCondition = {
    /** Indicates that the item is damaged. */
    DamagedCondition: "http://schema.org/DamagedCondition",
    /** Indicates that the item is new. */
    NewCondition: "http://schema.org/NewCondition",
    /** Indicates that the item is refurbished. */
    RefurbishedCondition: "http://schema.org/RefurbishedCondition",
    /** Indicates that the item is used. */
    UsedCondition: "http://schema.org/UsedCondition"
};
/** @deprecated Use OfferItemCondition as a variable instead. */
exports.OfferItemConditionEnum = exports.OfferItemCondition;
exports.OrderStatus = {
    /** OrderStatus representing cancellation of an order. */
    OrderCancelled: "http://schema.org/OrderCancelled",
    /** OrderStatus representing successful delivery of an order. */
    OrderDelivered: "http://schema.org/OrderDelivered",
    /** OrderStatus representing that an order is in transit. */
    OrderInTransit: "http://schema.org/OrderInTransit",
    /** OrderStatus representing that payment is due on an order. */
    OrderPaymentDue: "http://schema.org/OrderPaymentDue",
    /** OrderStatus representing availability of an order for pickup. */
    OrderPickupAvailable: "http://schema.org/OrderPickupAvailable",
    /** OrderStatus representing that there is a problem with the order. */
    OrderProblem: "http://schema.org/OrderProblem",
    /** OrderStatus representing that an order is being processed. */
    OrderProcessing: "http://schema.org/OrderProcessing",
    /** OrderStatus representing that an order has been returned. */
    OrderReturned: "http://schema.org/OrderReturned"
};
/** @deprecated Use OrderStatus as a variable instead. */
exports.OrderStatusEnum = exports.OrderStatus;
exports.PaymentStatusType = {
    /** An automatic payment system is in place and will be used. */
    PaymentAutomaticallyApplied: "http://schema.org/PaymentAutomaticallyApplied",
    /** The payment has been received and processed. */
    PaymentComplete: "http://schema.org/PaymentComplete",
    /** The payee received the payment, but it was declined for some reason. */
    PaymentDeclined: "http://schema.org/PaymentDeclined",
    /** The payment is due, but still within an acceptable time to be received. */
    PaymentDue: "http://schema.org/PaymentDue",
    /** The payment is due and considered late. */
    PaymentPastDue: "http://schema.org/PaymentPastDue"
};
/** @deprecated Use PaymentStatusType as a variable instead. */
exports.PaymentStatusTypeEnum = exports.PaymentStatusType;
exports.PhysicalActivityCategory = {
    /** Physical activity of relatively low intensity that depends primarily on the aerobic energy-generating process; during activity, the aerobic metabolism uses oxygen to adequately meet energy demands during exercise. */
    AerobicActivity: "http://schema.org/AerobicActivity",
    /** Physical activity that is of high-intensity which utilizes the anaerobic metabolism of the body. */
    AnaerobicActivity: "http://schema.org/AnaerobicActivity",
    /** Physical activity that is engaged to help maintain posture and balance. */
    Balance: "http://schema.org/Balance",
    /** Physical activity that is engaged in to improve joint and muscle flexibility. */
    Flexibility: "http://schema.org/Flexibility",
    /** Any physical activity engaged in for recreational purposes. Examples may include ballroom dancing, roller skating, canoeing, fishing, etc. */
    LeisureTimeActivity: "http://schema.org/LeisureTimeActivity",
    /** Any physical activity engaged in for job-related purposes. Examples may include waiting tables, maid service, carrying a mailbag, picking fruits or vegetables, construction work, etc. */
    OccupationalActivity: "http://schema.org/OccupationalActivity",
    /** Physical activity that is engaged in to improve muscle and bone strength. Also referred to as resistance training. */
    StrengthTraining: "http://schema.org/StrengthTraining"
};
/** @deprecated Use PhysicalActivityCategory as a variable instead. */
exports.PhysicalActivityCategoryEnum = exports.PhysicalActivityCategory;
exports.PhysicalExam = {
    /** Abdomen clinical examination. */
    Abdomen: "http://schema.org/Abdomen",
    /** Appearance assessment with clinical examination. */
    Appearance: "http://schema.org/Appearance",
    /** Cardiovascular system assessment withclinical examination. */
    CardiovascularExam: "http://schema.org/CardiovascularExam",
    /** Ear function assessment with clinical examination. */
    Ear: "http://schema.org/Ear",
    /** Eye or ophtalmological function assessment with clinical examination. */
    Eye: "http://schema.org/Eye",
    /** Genitourinary system function assessment with clinical examination. */
    Genitourinary: "http://schema.org/Genitourinary",
    /** Head assessment with clinical examination. */
    Head: "http://schema.org/Head",
    /** Lung and respiratory system clinical examination. */
    Lung: "http://schema.org/Lung",
    /** Musculoskeletal system clinical examination. */
    MusculoskeletalExam: "http://schema.org/MusculoskeletalExam",
    /** Neck assessment with clinical examination. */
    Neck: "http://schema.org/Neck",
    /** Neurological system clinical examination. */
    Neuro: "http://schema.org/Neuro",
    /** Nose function assessment with clinical examination. */
    Nose: "http://schema.org/Nose",
    /** Skin assessment with clinical examination. */
    Skin: "http://schema.org/Skin",
    /** Throat assessment with  clinical examination. */
    Throat: "http://schema.org/Throat"
};
/** @deprecated Use PhysicalExam as a variable instead. */
exports.PhysicalExamEnum = exports.PhysicalExam;
exports.ProductReturnEnumeration = {
    /** ProductReturnFiniteReturnWindow: there is a finite window for product returns. */
    ProductReturnFiniteReturnWindow: "http://schema.org/ProductReturnFiniteReturnWindow",
    /** ProductReturnNotPermitted: product returns are not permitted. */
    ProductReturnNotPermitted: "http://schema.org/ProductReturnNotPermitted",
    /** ProductReturnUnlimitedWindow: there is an unlimited window for product returns. */
    ProductReturnUnlimitedWindow: "http://schema.org/ProductReturnUnlimitedWindow",
    /** ProductReturnUnspecified: a product return policy is not specified here. */
    ProductReturnUnspecified: "http://schema.org/ProductReturnUnspecified"
};
/** @deprecated Use ProductReturnEnumeration as a variable instead. */
exports.ProductReturnEnumerationEnum = exports.ProductReturnEnumeration;
exports.RefundTypeEnumeration = {
    /** A ExchangeRefund ... */
    ExchangeRefund: "http://schema.org/ExchangeRefund",
    /** A FullRefund ... */
    FullRefund: "http://schema.org/FullRefund",
    /** A StoreCreditRefund ... */
    StoreCreditRefund: "http://schema.org/StoreCreditRefund"
};
/** @deprecated Use RefundTypeEnumeration as a variable instead. */
exports.RefundTypeEnumerationEnum = exports.RefundTypeEnumeration;
exports.ReservationStatusType = {
    /** The status for a previously confirmed reservation that is now cancelled. */
    ReservationCancelled: "http://schema.org/ReservationCancelled",
    /** The status of a confirmed reservation. */
    ReservationConfirmed: "http://schema.org/ReservationConfirmed",
    /** The status of a reservation on hold pending an update like credit card number or flight changes. */
    ReservationHold: "http://schema.org/ReservationHold",
    /** The status of a reservation when a request has been sent, but not confirmed. */
    ReservationPending: "http://schema.org/ReservationPending"
};
/** @deprecated Use ReservationStatusType as a variable instead. */
exports.ReservationStatusTypeEnum = exports.ReservationStatusType;
exports.RestrictedDiet = {
    /** A diet appropriate for people with diabetes. */
    DiabeticDiet: "http://schema.org/DiabeticDiet",
    /** A diet exclusive of gluten. */
    GlutenFreeDiet: "http://schema.org/GlutenFreeDiet",
    /** A diet conforming to Islamic dietary practices. */
    HalalDiet: "http://schema.org/HalalDiet",
    /** A diet conforming to Hindu dietary practices, in particular, beef-free. */
    HinduDiet: "http://schema.org/HinduDiet",
    /** A diet conforming to Jewish dietary practices. */
    KosherDiet: "http://schema.org/KosherDiet",
    /** A diet focused on reduced calorie intake. */
    LowCalorieDiet: "http://schema.org/LowCalorieDiet",
    /** A diet focused on reduced fat and cholesterol intake. */
    LowFatDiet: "http://schema.org/LowFatDiet",
    /** A diet appropriate for people with lactose intolerance. */
    LowLactoseDiet: "http://schema.org/LowLactoseDiet",
    /** A diet focused on reduced sodium intake. */
    LowSaltDiet: "http://schema.org/LowSaltDiet",
    /** A diet exclusive of all animal products. */
    VeganDiet: "http://schema.org/VeganDiet",
    /** A diet exclusive of animal meat. */
    VegetarianDiet: "http://schema.org/VegetarianDiet"
};
/** @deprecated Use RestrictedDiet as a variable instead. */
exports.RestrictedDietEnum = exports.RestrictedDiet;
exports.ReturnFeesEnumeration = {
    /** OriginalShippingFees ... */
    OriginalShippingFees: "http://schema.org/OriginalShippingFees",
    /** RestockingFees ... */
    RestockingFees: "http://schema.org/RestockingFees",
    /** ReturnShippingFees ... */
    ReturnShippingFees: "http://schema.org/ReturnShippingFees"
};
/** @deprecated Use ReturnFeesEnumeration as a variable instead. */
exports.ReturnFeesEnumerationEnum = exports.ReturnFeesEnumeration;
exports.RsvpResponseType = {
    /** The invitee may or may not attend. */
    RsvpResponseMaybe: "http://schema.org/RsvpResponseMaybe",
    /** The invitee will not attend. */
    RsvpResponseNo: "http://schema.org/RsvpResponseNo",
    /** The invitee will attend. */
    RsvpResponseYes: "http://schema.org/RsvpResponseYes"
};
/** @deprecated Use RsvpResponseType as a variable instead. */
exports.RsvpResponseTypeEnum = exports.RsvpResponseType;
exports.SteeringPositionValue = {
    /** The steering position is on the left side of the vehicle (viewed from the main direction of driving). */
    LeftHandDriving: "http://schema.org/LeftHandDriving",
    /** The steering position is on the right side of the vehicle (viewed from the main direction of driving). */
    RightHandDriving: "http://schema.org/RightHandDriving"
};
/** @deprecated Use SteeringPositionValue as a variable instead. */
exports.SteeringPositionValueEnum = exports.SteeringPositionValue;
